export default "__VITE_ASSET__B7ky8gIf__"